/**
 * Normalises Google Cloud Storage URLs so they work in all browsers.
 *
 * `storage.cloud.google.com` is the authenticated GCS console endpoint — it
 * requires an active Google session in the browser.  Safari (and any browser
 * without a Google session) will receive a 403.
 *
 * `storage.googleapis.com` is the public CDN endpoint and works everywhere.
 */
export function normalizeImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;

  if (url.includes("storage.cloud.google.com")) {
    return url
      .replace("storage.cloud.google.com", "storage.googleapis.com")
      .replace(/%2F/gi, "/");
  }

  return url;
}
